/**
 * @generated SignedSource<<1da8c959486565bdf453432d35be9950>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type composerQueriesImagesGalleryImagesQueriesCategoriesFragmentQuery$variables = {
  isLibrary?: boolean | null;
  onlybackground?: boolean | null;
};
export type composerQueriesImagesGalleryImagesQueriesCategoriesFragmentQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"composerQueriesImagesGalleryImagesQueriesCategories_fragment">;
};
export type composerQueriesImagesGalleryImagesQueriesCategoriesFragmentQuery = {
  response: composerQueriesImagesGalleryImagesQueriesCategoriesFragmentQuery$data;
  variables: composerQueriesImagesGalleryImagesQueriesCategoriesFragmentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isLibrary"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "onlybackground"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasImages",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSystemwide",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfProducts",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "composerQueriesImagesGalleryImagesQueriesCategoriesFragmentQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "composerQueriesImagesGalleryImagesQueriesCategories_fragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "composerQueriesImagesGalleryImagesQueriesCategoriesFragmentQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "isLibrary",
            "variableName": "isLibrary"
          },
          {
            "kind": "Variable",
            "name": "onlybackground",
            "variableName": "onlybackground"
          }
        ],
        "concreteType": "ImageMacroCategory",
        "kind": "LinkedField",
        "name": "imageMacroCategories",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "onlyForBackgrounds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "macroCategoryPosition",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ImageCategory",
            "kind": "LinkedField",
            "name": "categories",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "categoryPosition",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5b93b800b739c73b8c2ef6989d2e52bf",
    "id": null,
    "metadata": {},
    "name": "composerQueriesImagesGalleryImagesQueriesCategoriesFragmentQuery",
    "operationKind": "query",
    "text": "query composerQueriesImagesGalleryImagesQueriesCategoriesFragmentQuery(\n  $isLibrary: Boolean\n  $onlybackground: Boolean\n) {\n  ...composerQueriesImagesGalleryImagesQueriesCategories_fragment\n}\n\nfragment composerQueriesImagesGalleryImagesQueriesCategories_fragment on Query {\n  imageMacroCategories(onlybackground: $onlybackground, isLibrary: $isLibrary) {\n    id\n    name\n    hasImages\n    isSystemwide\n    numberOfProducts\n    onlyForBackgrounds\n    macroCategoryPosition\n    categories {\n      id\n      name\n      hasImages\n      isSystemwide\n      numberOfProducts\n      categoryPosition\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6b77591cb59dc6676fab55d1b5ba83bd";

export default node;
